/**
 * Простой сидированный ГПСЧ для заглушки (mulberry32, 32-битная целочисленная арифметика).
 * Настоящий ГПСЧ боя — задача E1 (`src/sim/`); заглушка от него не зависит.
 */
export interface FakeRng {
  /** Следующее беззнаковое 32-битное целое. */
  nextU32(): number;
  /** Целое в `[min, max]` включительно. */
  int(min: number, max: number): number;
}

export function createFakeRng(seed: number): FakeRng {
  let s = seed >>> 0;
  const nextU32 = (): number => {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return (t ^ (t >>> 14)) >>> 0;
  };
  return {
    nextU32,
    int(min, max) {
      return min + (nextU32() % (max - min + 1));
    },
  };
}
